import React from 'react'

import { Helmet } from 'react-helmet'

import './extended-portfolio.css'

const ExtendedPortfolio = (props) => {
  return (
    <div className="extended-portfolio-container">
      <Helmet>
        <title>Extended-Portfolio - Ruby Smith | MIXSMITH</title>
        <meta
          property="og:title"
          content="Extended-Portfolio - Ruby Smith | MIXSMITH"
        />
        <link
          rel="canonical"
          href="https://rubysmithxyz.teleporthq.app/extended-portfolio"
        />
      </Helmet>
    </div>
  )
}

export default ExtendedPortfolio
